import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutComponent } from '../about/about.component';
import { MahaagxDpiComponent } from '../mahaagx-dpi/mahaagx-dpi.component';
import { HowItWorksComponent } from '../how-it-works/how-it-works.component';
import { CoreCapabilitiesComponent } from '../core-capabilities/core-capabilities.component';
import { KeyPlatformFeaturesComponent } from '../key-platform-features/key-platform-features.component';
import { VisionStatementComponent } from '../vision-statement/vision-statement.component';
import { KeyObjectivesComponent } from '../key-objectives/key-objectives.component';
import { BenefitsComponent } from '../benefits/benefits.component';
import { PrinciplesComponent } from '../principles/principles.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';

@Component({
  selector: 'app-about-us-home',
  standalone: true,
  imports: [
    CommonModule,
    AboutComponent,
    MahaagxDpiComponent,
    HowItWorksComponent,
    CoreCapabilitiesComponent,
    KeyPlatformFeaturesComponent,
    VisionStatementComponent,
    KeyObjectivesComponent,
    BenefitsComponent,
    PrinciplesComponent,
    FooterComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class AboutUsHomeComponent {}

